import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Fragment from 'flarum/common/Fragment';
export default class AutocompleteDropdown extends Fragment {
  constructor() {
    super(...arguments);
    _defineProperty(this, "items", []);
    _defineProperty(this, "active", false);
    _defineProperty(this, "index", 0);
    _defineProperty(this, "keyWasJustPressed", false);
    _defineProperty(this, "keyWasJustPressedTimeout", null);
  }
  view() {
    return m("ul", {
      className: "Dropdown-menu EmojiDropdown"
    }, m("li", {
      className: "Dropdown-header"
    }, app.translator.trans('flarum-emoji.forum.composer.type_to_search_text')), this.items.map(item => {
      var _attrs;
      return m("li", {
        key: (_attrs = item.attrs) == null ? void 0 : _attrs.key
      }, item);
    }));
  }
  show(left, top) {
    this.$().show().css({
      left: (left != null ? left : 0) + 'px',
      top: (top != null ? top : 0) + 'px'
    });
    this.active = true;
  }
  hide() {
    this.$().hide();
    this.active = false;
  }
  navigate(delta) {
    this.keyWasJustPressed = true;
    this.setIndex(this.index + delta, true);
    if (this.keyWasJustPressedTimeout) clearTimeout(this.keyWasJustPressedTimeout);
    this.keyWasJustPressedTimeout = setTimeout(() => this.keyWasJustPressed = false, 500);
  }
  complete() {
    this.$('li:not(.Dropdown-header)').eq(this.index).find('button').click();
  }
  setIndex(index, scrollToItem) {
    if (this.keyWasJustPressed && !scrollToItem) return;
    const $dropdown = this.$();
    const $items = $dropdown.find('li:not(.Dropdown-header)');
    let rangedIndex = index;
    if (rangedIndex < 0) {
      rangedIndex = $items.length - 1;
    } else if (rangedIndex >= $items.length) {
      rangedIndex = 0;
    }
    this.index = rangedIndex;
    const $item = $items.removeClass('active').eq(rangedIndex).addClass('active');
    if (scrollToItem) {
      const dropdownScroll = $dropdown.scrollTop();
      const dropdownTop = $dropdown.offset().top;
      const dropdownBottom = dropdownTop + $dropdown.outerHeight();
      const itemTop = $item.offset().top;
      const itemBottom = itemTop + $item.outerHeight();
      let scrollTop;
      if (itemTop < dropdownTop) {
        scrollTop = dropdownScroll - dropdownTop + itemTop - parseInt($dropdown.css('padding-top'), 10);
      } else if (itemBottom > dropdownBottom) {
        scrollTop = dropdownScroll - dropdownBottom + itemBottom + parseInt($dropdown.css('padding-bottom'), 10);
      }
      if (typeof scrollTop !== 'undefined') {
        $dropdown.stop(true).animate({
          scrollTop
        }, 100);
      }
    }
  }
}
flarum.reg.add('flarum-emoji', 'forum/fragments/AutocompleteDropdown', AutocompleteDropdown);